$(document).ready(function(){
  
  // -- Settings --
  var gallerySettings = {
    'arrows': true,
    'dots': true,
    'autoplay': true,
    'pauseOnDotsHover': true,
    'responsive': [
      {
        'breakpoint': 767,
        'settings': {
          'arrows': false,
          'adaptiveHeight': true
        }
      }
    ]
  };

  var galleryCampingPitchesSettings = {
  	'arrows': true,
    'autoplay': true,
  };

  var homeNewsSettings = {
  	'arrows': true,
  	'slidesToShow': 2,
    'responsive': [
      {
        'breakpoint': 768,
        'settings': {
          // 'arrows': false,
          'slidesToShow': 1
        }
      }
    ]
  };

  var homeCampingPitchesSettings = {
    'arrows': true,
    'asNavFor': '.slider__sync'
  }

  var homeCampingPitchesGallerySettings = {
    'arrows': false,
    'asNavFor': '.slider__sync'
  }

  // Slider init --
  
  $('.slider--gallery').slick(gallerySettings);
  $('.slider--gallery--campingPitches').slick(galleryCampingPitchesSettings);
  $('.home__slider--news').slick(homeNewsSettings);
  $('.home__slider--campingPitches').slick(homeCampingPitchesSettings);
  $('.home__slider--campingPitchesGallery').slick(homeCampingPitchesGallerySettings);

});